<template>
  <section
    class="blade-product"
    :class="[container === 'full' ? 'container-fluid' : 'container']"
    :style="`background:url(${require('../assets/' +
      content.background)}) ${imagePos} no-repeat; background-size: ${backgroundFill};`"
  >
    <div class="row">
      <div
        class="col-12 col-lg-5"
        :class="[alignment === 'right' ? 'offset-lg-7' : '']"
      >
        <div class="content-area">
          <h2 v-html="content.product"></h2>
          <p v-html="content.copy"></p>
          <ul class="list-inline list-price">
            <li class="list-inline-item reduced">
              <strike>${{ content.cost.normal }}</strike>
            </li>
            <li class="list-inline-item">${{ content.cost.reduced }}</li>
          </ul>
          <ul class="list-inline">
            <li class="list-inline-item">
              <b-button
                :variant="btnMain"
                to="/products/headphones/quiet-comfort-earbud"
                >Buy</b-button
              >
            </li>
            <li class="list-inline-item">
              <b-button
                :variant="btnSecondary"
                to="/products/headphones/quiet-comfort-earbud"
                >Learn</b-button
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "blade-product",
  props: {
    alignment: {
      type: String,
      default: "left",
    },
    container: {
      type: String,
      default: "default",
    },
    content: {
      type: Object,
    },
    btnMain: {
      type: String,
      default: "black",
    },
    btnSecondary: {
      type: String,
      default: "gray",
    },
    imagePos: {
      type: String,
      default: "0 50%",
    },
  },
  computed: {
    backgroundFill() {
      return this.content.backgroundFill
        ? this.content.backgroundFill
        : "cover";
    },
  },
};
</script>

<style scoped lang="scss">
.blade-product {
  padding-top: 50%;
  position: relative;
  margin-top: 30px;
  margin-bottom: 30px;
  @media screen and (min-width: map-get($grid-breakpoints,sm)) {
    padding-top: 35%;
  }
  @media screen and (max-width: map-get($grid-breakpoints,lg)) {
    background-position: center top !important;
  }
  @media screen and (min-width: map-get($grid-breakpoints,lg)) {
    padding-top: 45%;
    margin-top: 0;
    margin-bottom: 0;
  }
  @media screen and (min-width: map-get($grid-breakpoints,xl)) {
    padding-top: 600px;
  }
  & > .row > div {
    @media screen and (min-width: map-get($grid-breakpoints,lg)) {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
    }
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
  }
}
.list-price {
  font-size: 22px;
  .reduced {
    color: #999;
  }
}
.content-area {
  text-align: center;
  h2,
  p,
  strong {
  }
  .header-eyebrow {
    font-size: 20px;
  }
  h2 {
    font-size: 36px;
  }
}
</style>
